export default __webpack_public_path__ + "static/media/cms_energytaskforce_logo.10394dbf.png";